import React from 'react';

const JS_2017 = () => {
  return (
    <div >
      <h1>JS_2017</h1>
      <p>Placeholder component for: "JS 2017"</p>
    </div>
  );
};

export default JS_2017;
